import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/logistics/LogisticsClient.tsx");
